import {Redirect, Route} from 'react-router-dom';
import React from 'react';

const PrivateRoute = ({component: Component, ...rest}) => (
  <Route {...rest} render={props => (
    JSON.parse(sessionStorage.getItem('usuarioLogado')) ?
      <Component {...props} />
    :
    <Redirect to="/login" />
  )} />
);

export default PrivateRoute;
